var map = {
	"./avatar.svg": 553,
	"./copy.png": 1864,
	"./db-logos/Cassandra.png": 1865,
	"./db-logos/arangodb.png": 1866,
	"./db-logos/athena.png": 1867,
	"./db-logos/aws_es.png": 1868,
	"./db-logos/axibasetsd.png": 1869,
	"./db-logos/azure_kusto.png": 1870,
	"./db-logos/bigquery.png": 1871,
	"./db-logos/bigquery_gce.png": 1872,
	"./db-logos/clickhouse.png": 1873,
	"./db-logos/cloudwatch.png": 1874,
	"./db-logos/cloudwatch_insights.png": 1875,
	"./db-logos/cockroach.png": 1876,
	"./db-logos/corporate_memory.png": 1877,
	"./db-logos/couchbase.png": 1878,
	"./db-logos/csv.png": 1879,
	"./db-logos/databricks.png": 1880,
	"./db-logos/db2.png": 1881,
	"./db-logos/dgraph.png": 1882,
	"./db-logos/drill.png": 1883,
	"./db-logos/druid.png": 1884,
	"./db-logos/dynamodb_sql.png": 1885,
	"./db-logos/elasticsearch.png": 1886,
	"./db-logos/elasticsearch2.png": 1887,
	"./db-logos/elasticsearch2_OpenDistroSQLElasticSearch.png": 1888,
	"./db-logos/elasticsearch2_XPackSQLElasticSearch.png": 1889,
	"./db-logos/exasol.png": 1890,
	"./db-logos/excel.png": 1891,
	"./db-logos/firebolt.png": 1892,
	"./db-logos/google_analytics.png": 1893,
	"./db-logos/google_spreadsheets.png": 1894,
	"./db-logos/graphite.png": 1895,
	"./db-logos/hive.png": 1896,
	"./db-logos/hive_http.png": 1897,
	"./db-logos/impala.png": 1898,
	"./db-logos/influxdb.png": 1899,
	"./db-logos/jirajql.png": 1900,
	"./db-logos/json.png": 1901,
	"./db-logos/kibana.png": 1902,
	"./db-logos/kylin.png": 1903,
	"./db-logos/mapd.png": 1904,
	"./db-logos/memsql.png": 1905,
	"./db-logos/mongodb.png": 1906,
	"./db-logos/mssql.png": 1907,
	"./db-logos/mssql_odbc.png": 1908,
	"./db-logos/mysql.png": 1909,
	"./db-logos/nz.png": 1910,
	"./db-logos/oracle.png": 1911,
	"./db-logos/pg.png": 1912,
	"./db-logos/phoenix.png": 1913,
	"./db-logos/pinot.png": 1914,
	"./db-logos/presto.png": 1915,
	"./db-logos/prometheus.png": 1916,
	"./db-logos/python.png": 1917,
	"./db-logos/qubole.png": 1918,
	"./db-logos/rds_mysql.png": 1919,
	"./db-logos/redshift.png": 1920,
	"./db-logos/redshift_iam.png": 1921,
	"./db-logos/results.png": 1922,
	"./db-logos/rockset.png": 1923,
	"./db-logos/salesforce.png": 1924,
	"./db-logos/scylla.png": 1925,
	"./db-logos/snowflake.png": 1926,
	"./db-logos/sparql_endpoint.png": 1927,
	"./db-logos/sqlite.png": 1928,
	"./db-logos/treasuredata.png": 1929,
	"./db-logos/trino.png": 1930,
	"./db-logos/uptycs.png": 1931,
	"./db-logos/url.png": 1932,
	"./db-logos/vertica.png": 1933,
	"./db-logos/yandex_appmetrika.png": 1934,
	"./db-logos/yandex_metrika.png": 1935,
	"./destinations/chatwork.png": 1936,
	"./destinations/email.png": 1937,
	"./destinations/hangouts_chat.png": 1938,
	"./destinations/hipchat.png": 1939,
	"./destinations/mattermost.png": 1940,
	"./destinations/microsoft_teams_webhook.png": 1941,
	"./destinations/pagerduty.png": 1942,
	"./destinations/slack.png": 1943,
	"./destinations/webhook.png": 1944,
	"./favicon-16x16.png": 1945,
	"./favicon-32x32.png": 1946,
	"./favicon-96x96.png": 1947,
	"./favicon.png": 1948,
	"./favicon_1.png": 1949,
	"./fixtures/map-tile.png": 1950,
	"./google_logo.svg": 1951,
	"./illustrations/alert.svg": 1952,
	"./illustrations/dashboard.svg": 1953,
	"./illustrations/no-query-results.svg": 1954,
	"./illustrations/query.svg": 1955,
	"./logo.png": 1956,
	"./logo_white.png": 1957,
	"./redash_icon_small.png": 144,
	"./redash_icon_small_1.png": 1958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1863;